module.exports = __webpack_public_path__ + "img/sebastian-hagens-2.57d47697.jpg";